import { AppMode, BetbyBonusBehavior, CatalogFilter, EndpointType, Theme } from '../types.js';
// SEO configuration for Luna brand
const seoConfig = {
    companyName: 'Luna Crypto Casino',
    routes: {
        '/': {
            title: 'Luna Crypto Casino | Sportsbook, Live Casino & Instant Withdrawals',
            description: 'Play slots, live casino & bet on sports at Luna Crypto Casino. Crypto casino with instant withdrawals, provably fair games & 24/7 support.'
        },
        '/casino': {
            title: 'Online Casino | Slots, Blackjack & Live Dealers | Luna Crypto Casino',
            description: 'Play slots, blackjack, roulette & live dealers at Luna Crypto Casino. Hundreds of games, fast crypto deposits & instant withdrawals available 24/7.'
        },
        '/sports': {
            title: 'Online Sportsbook | Crypto Sports Betting & Odds | Luna Crypto Casino',
            description: 'Bet on sports at Luna Crypto Casino. Competitive odds on football, basketball & more. Live betting, secure crypto wagering & fast payouts.'
        },
        '/about-us': {
            title: 'About Us | Learn More About Luna Crypto Casino',
            description: 'Learn about Luna Crypto Casino, a leading crypto casino & sportsbook. Committed to secure, fair & thrilling gambling with instant crypto withdrawals.'
        },
        '/affiliate': {
            title: 'Affiliate Program | Earn Crypto with Luna Crypto Casino',
            description: 'Partner with Luna Crypto Casino & earn commissions promoting our crypto casino. Competitive rates, real-time tracking & dedicated affiliate support.'
        },
        '/aml-policy': {
            title: 'AML Policy | Anti-Money Laundering at Luna Crypto Casino',
            description: "Luna Crypto Casino's AML policy ensures a secure, trustworthy environment. Read about our measures to prevent illicit activity on our platform."
        },
        '/bonus-terms': {
            title: 'Bonus Terms & Conditions | Luna Crypto Casino Promotions',
            description: "Read the rules for Luna Crypto Casino's bonuses & promotions. Learn how to claim, use & withdraw bonus winnings from our platform."
        },
        '/complaints-and-arbitration': {
            title: 'Complaints and Arbitration | Player Support at Luna Crypto Casino',
            description: "Find Luna Crypto Casino's complaint & dispute resolution process. We ensure fair treatment and resolve player issues quickly and transparently."
        },
        '/fairness': {
            title: 'Provably Fair Games | Ensure Fairness at Luna Crypto Casino',
            description: 'Luna Crypto Casino uses provably fair technology to guarantee every game result is verifiable, transparent & completely random.'
        },
        '/fairness/overview': {
            title: 'Provably Fair Gaming Overview | Luna Crypto Casino',
            description: "Luna Crypto Casino's provably fair system explained. Cryptographic principles guaranteeing game integrity & complete randomness on every result."
        },
        '/favorites': {
            title: 'Your Favorite Games | Quick Access | Luna Crypto Casino',
            description: 'Access your saved casino games at Luna Crypto Casino. Your personal list of top slots, table games & live dealers, always one click away.'
        },
        '/featurebuyin': {
            title: 'Feature Buy-In Slots | Skip to Bonus Rounds | Luna Crypto Casino',
            description: "Skip straight to bonus rounds with Luna Crypto Casino's feature buy-in slots. Instantly trigger bonus features for a chance at big wins."
        },
        '/gameshows': {
            title: 'Live Gameshows | Play Casino Gameshows at Luna Crypto Casino',
            description: 'Play live casino gameshows at Luna Crypto Casino. Enjoy Crazy Time, Monopoly Live & more, hosted by professional dealers in real time.'
        },
        '/kyc-policy': {
            title: 'KYC Policy | Know Your Customer at Luna Crypto Casino',
            description: "Luna Crypto Casino's KYC policy outlines our identity verification process. Learn how we protect players and maintain a secure gaming environment."
        },
        '/livecasino': {
            title: 'Live Casino | Blackjack, Roulette & Live Dealers | Luna Crypto Casino',
            description: 'Play blackjack, roulette & live casino games at Luna Crypto Casino. Real dealers, HD streaming & a wide selection of live tables available 24/7.'
        },
        '/newgames': {
            title: 'New Casino Games | Latest Slots & Live Games | Luna Crypto Casino',
            description: 'Play the latest casino games at Luna Crypto Casino. Regularly updated with new slots & table games from top providers. Be first to play.'
        },
        '/payment-policy': {
            title: 'Payment Policy | Crypto Deposits & Withdrawals | Luna Crypto Casino',
            description: 'Luna Crypto Casino accepts crypto deposits & withdrawals. Read our payment policy for transaction limits, accepted coins & processing times.'
        },
        '/populargames': {
            title: 'Popular Casino Games | Top Slots & Live Games | Luna Crypto Casino',
            description: 'Play the most popular casino games at Luna Crypto Casino. Top-rated slots & table games loved by our community, available with crypto.'
        },
        '/privacy-policy': {
            title: 'Privacy Policy | Data Protection at Luna Crypto Casino',
            description: "Luna Crypto Casino's privacy policy. Learn how we collect, use & protect your personal data on our crypto casino platform."
        },
        '/promotion-page': {
            title: 'Casino Promotions | Bonuses & Special Offers | Luna Crypto Casino',
            description: "Browse Luna Crypto Casino's latest promotions. Current bonuses, tournaments & special events – claim your offer and start playing."
        },
        '/providers': {
            title: 'Game Providers | Partnered Studios & Software | Luna Crypto Casino',
            description: 'Explore all game providers at Luna Crypto Casino. We partner with top studios to bring you a diverse, high-quality crypto casino library.'
        },
        '/referral': {
            title: 'Referral Program | Invite Friends & Earn Rewards | Luna Crypto Casino',
            description: 'Refer friends to Luna Crypto Casino & earn rewards when they sign up and play. Share your link and collect bonuses for every referral.'
        },
        '/responsible-gaming': {
            title: 'Responsible Gaming | Play Safely at Luna Crypto Casino',
            description: 'Luna Crypto Casino is committed to responsible gambling. Access tools & resources to manage your gaming habits and play safely.'
        },
        '/slots': {
            title: 'Online Slots | Wide Variety of Casino Slots | Luna Crypto Casino',
            description: 'Spin a massive collection of slots at Luna Crypto Casino. Classic fruit machines, video slots & progressives – all playable with crypto.'
        },
        '/terms-of-service': {
            title: 'Terms of Service | Luna Crypto Casino',
            description: 'Review the terms & conditions governing your use of Luna Crypto Casino. Understand your rights and responsibilities as a player.'
        },
        '/terms-sports': {
            title: 'Sports Betting Terms & Conditions | Luna Crypto Casino',
            description: "Luna Crypto Casino's sports betting terms & conditions. Rules for placing bets, winning payouts & sportsbook usage on our platform."
        },
        '/vip': {
            title: 'VIP Program | Exclusive Rewards & Benefits | Luna Crypto Casino',
            description: "Luna Crypto Casino's VIP program: exclusive rewards, personalised bonuses & priority support. Tailored perks for loyal players."
        },
        '/welcome-offer': {
            title: 'Welcome Bonus Offer | Sign Up & Get Your Bonus | Luna Crypto Casino',
            description: "Claim Luna Crypto Casino's welcome bonus on your first deposit. Learn how to get started and make the most of our sign-up offer."
        }
    },
    titlePatterns: {
        game: 'Play ${game} Online Casino Game by ${provider} | ${brand}',
        provider: '${provider} Online Casino Games | ${brand}',
        sport: '${sport} Sports Betting | ${brand}',
        default: 'Play Crypto Casino Games | ${brand}'
    },
    descriptionPatterns: {
        game: '${game} by ${provider}, play online with Crypto or free with demo play at Luna.',
        provider: 'Play top online slots by ${provider} at Luna. Discover popular games, enjoy free demo play, or spin with crypto for exciting real-money action.',
        sport: 'Stay updated on ${sport} with the latest scores, news, and expert insights. Get in-depth coverage of every match, player stats, and highlights all in one place.'
    }
};
const themeSetting = {
    theme: Theme.Luna,
    rankConfig: { sublevelFormat: 'numeric' },
    betbyEnabled: true,
    betbyBonusBehavior: BetbyBonusBehavior.NoBonusMoney,
    betbyThemeName: 'default',
    brand: 'lunabet.com',
    brandTitle: 'Lunabet',
    canonicalUrl: 'https://lunabet.com',
    cdnBase: 'https://d3r5y5kwxjm7vw.cloudfront.net',
    cdnTiles: 'https://tiles.fomo.io',
    cdnBanners: 'https://images.fomo.io/',
    discordLink: '',
    googleAnalytics: '',
    googleClientId: undefined, //'1030216308308-9ceh2uirt0ltfdb0duunbmg83kp41s9a.apps.googleusercontent.com',
    googleTagManager: undefined,
    languageDefault: 'tr',
    languages: ['en', 'tr'],
    languagesTiles: ['en', 'tr'],
    languagesAutoAccept: ['en', 'tr'],
    intercomId: 'e6olp9gz',
    supportEmail: 'support@lunabet.com',
    telegramLink: undefined,
    xLink: undefined,
    noIndex: true,
    gameSetLimit: 60,
    themePath: 'fomoio',
    verbiageLabel: 'fomoio',
    ui: {
        mobileMenu: {
            mobileMenuStyle: 'alternative4',
            showRewardsAndPromo: false,
            showChat: false,
            showLunaSpecialBets: true,
            showJackpot: true,
            itemOrder: ['menu', 'sports', 'luna-special-bets', 'casino', 'jackpot']
        },
        accordion: {
            accordionStyle: 'alternative4'
        },
        auth: {
            useSolidAccentOAuthButton: true,
            showWalletConnect: false,
            useTightModalBodyPadding: true,
            useOffsetModalCloseButton: false,
            hideReferalCode: true
        },
        background: {
            backgroundStyle: 'solid'
        },
        bannerSwiper: {
            bannerSwiperStyle: 'alternative'
        },
        cardSwiper: {
            cardSwiperStyle: 'alternative4',
            viewAllAsButton: false,
            showNavigationArrows: true,
            disableEdgeMask: true
        },
        button: {
            buttonStyle: 'contrast',
            useUppercaseAsDefault: true
        },
        betby: {
            betslipBottom: 20,
            customUI: true
        },
        betfeed: {
            betfeedStyle: 'default',
            usedVerbiage: 'live'
        },
        cashier: {
            useAcceptDeclineBonusType: true,
            withdrawOnlyUsdt: true,
            withdrawOnlyUsdtMemeCoins: true,
            showConversionRateDeposit: false,
            showWiddrawalOnlyUSDT: false,
            showProgressBarBonusMoney: false,
            useBuyCryptoIFrame: false,
            buyCryptoMaxAmount: 5000,
            buyCryptoMinAmount: 15,
            showQrCodeBuyCrypto: false,
            useSearchInputOnCryptoDropdown: false,
            showImageOnDepositBonusOffers: true,
            depositBonusWageringContributions: [
                { category: 'slots', percentage: 100 },
                { category: 'originals', percentage: 5 },
                { category: 'live_casino', percentage: 0 },
                { category: 'table_games', percentage: 0 }
            ],
            showWithdrawalWarningIfNoFunds: true,
            showWithdrawalPlayRequirementImmediately: true,
            cashierStyle: 'alternative4',
            useCashierHomeScreen: true,
            useSidetabs: false,
            buyCryptoEnabled: false,
            useCashierV4: false,
            useCompactDepositAddressOptionLayout: true,
            extendCashierVerbiageKeysWithBrandLabel: true,
            useVerificationStep: false
        },
        casinoLobby: {
            casinoLobbyStyle: 'alternative4',
            showLiveWins: true,
            useAlternateOriginalsCategoryTitle: true
        },
        chat: {
            chatStyle: 'alternative4'
        },
        checkbox: {
            useAlternativeTick: false,
            checkboxStyle: 'alternative'
        },
        dropdown: {
            dropdownStyle: 'alternative4',
            useDropdownBackgroundImage: false
        },
        emailVerify: {
            emailVerifyStyle: 'alternative4'
        },
        footer: {
            footerStyle: 'alternative4',
            useEmbeddedShellDecor: false
        },
        games: {
            showRacesLeaderboard: false,
            showNavigationOnMobile: false,
            showLikeButton: false,
            showLogoWhenPlayingDesktop: false,
            showGameInfoModalOnGamePathMobile: false,
            applyPedestalIllustrationHueShift: true,
            useCompactRacesLeaderboardInfoBackdrop: true,
            showRacesLeaderboardPerimeterIllustrations: false
        },
        header: {
            headerStyle: 'alternative4',
            buttonLoginVariant: 'secondary',
            useTightRewardsToggleHorizontalPadding: false
        },
        helpdesk: {
            useDynamicBonusTerms: true
        },
        home: {
            homeStyle: 'alternative4',
            showBuyCryptoBanner: false,
            showLiveWins: true,
            cryptoBannerStyle: 'alternative',
            buyCryptoBannerArtStyle: 'minimal',
            useAlternateOriginalsCategoryTitle: true,
            showAdventCalendarPage: false
        },
        icons: {
            vipHeaderGlyphDarkFill: false,
            statusIconsUseWarmPalette: true,
            expandSectionToggleUsesMintAccent: false,
            navIconPickerAllowRemoteAssets: true,
            navIconPickerUseBundledIconFactories: false
        },
        infoCard: {
            infoCardStyle: 'solid-dark'
        },
        input: {
            inputStyle: 'alternative'
        },
        layout: {
            layoutStyle: 'alternative4',
            isContrastTextColor: true,
            useCompactVerticalPagePadding: true,
            useReducedMarginsInHomePage: false,
            useCurrentColorSidebar: true,
            useReferralIconAnimated: false,
            useNewIcons: false,
            useRemoteIcons: false,
            showCryptoPriceDropdown: false,
            showNotInCatalogGames: false,
            showUpdownGameDropdown: false,
            useReferralBannerOnlyImageCustom: true,
            usePromoItemContentCustom: true,
            useCentralButtonOnMobileMenu: false,
            sectionIconSize: 24,
            useExpandedRankPresentation: true,
            useAlternateMobileSidebarBackdrop: true,
            embedWebSiteOrganizationJsonLd: false
        },
        liveWins: {
            liveWinsStyle: 'alternative',
            usedVerbiage: 'live_wins',
            useSpecialWinCards: false
        },
        loading: {
            useLottie: false,
            publicInitPageLoadDisplayFor: 3000,
            playerInitPageLoadDisplayFor: 3000,
            useCustomLoading: true
        },
        maintenance: {
            maintenanceStyle: 'default',
            contentSource: 'hardcoded',
            useUppercaseBrandTitle: true
        },
        geoblock: {
            contentSource: 'hardcoded'
        },
        modal: {
            modalStyle: 'tinted'
        },
        walletDropdown: {
            showBalancePreferenceToggles: false
        },
        notifications: {
            notificationsStyle: 'alternative4',
            useBorderedPlayerNotificationsIcon: true,
            useGradientPublicNotificationsIcon: true,
            useExtendedDepositNotificationTitles: true
        },
        toasts: {
            toastsStyle: 'default',
            isLocalIcon: true
        },
        profileModal: {
            profileModalStyle: 'alternative4',
            showFavouriteSection: false,
            useStarsBackgroundOnFavouriteToken: false,
            useTokenArtBackgroundOnDesktop: true,
            useCompactFavouriteTokenMobileCard: true
        },
        promotions: {
            showExpiredPromotions: false,
            useAspectRatioBoxDetailCustom: true,
            limitedCashbackExpired: new Date('2027-01-01T00:00:00Z').getTime(),
            promotionsStyle: 'alternative'
        },
        provider: {
            providerStyle: 'alternative4',
            useSolidPrimaryGameCountBadge: true,
            hideProvidersHeroTitle: true
        },
        referral: {
            referralDashboardBannerType: 'onlyImage',
            faqTitleStyle: 'headline',
            faqVisibilityPreset: 'all',
            accordionGlassStyle: false,
            rulesCardsStyle: 'illustrated',
            rulesFootnoteMuted: false,
            highlightStepTitles: true,
            rankProgressPalette: 'warm',
            usePrefixedVerbiageKeys: true,
            shareModalStyle: 'rich',
            shareMessageVariant: 'campaign',
            shareBannerStyle: 'elevated',
            referralDashboardBannerStyle: 'elevated'
        },
        transparency: {
            enabled: true
        },
        affiliates: {
            enabled: false,
            usePrefixedVerbiageKeys: true
        },
        rewardsDropdown: {
            rewardsDropdownStyle: 'alternative',
            useComfortableRewardsTimerLabels: true,
            showSeasonalRewardsCampaignTabs: false
        },
        settings: {
            settingsStyle: 'alternative',
            useAlternateSettingsChrome: true
        },
        sidebar: {
            sidebarStyle: 'alternative4',
            showLuckyDip: false,
            showBanner: false
        },
        table: {
            tableStyle: 'alternative'
        },
        tabs: {
            tabsStyle: 'alternative4',
            useCompactTabStripRadius: true,
            tabButtonsDefaultVariant: 'primary'
        },
        text: {
            successTextUsesWarmTone: true
        },
        toggle: {
            toggleStyle: 'alternative'
        },
        tooltip: {
            tooltipStyle: 'alternative'
        },
        topSection: {
            casinoTopSectionStyle: 'alternative'
        },
        transactions: {
            transactionsStyle: 'alternative',
            useSegmentedTabs: true,
            useElevatedRows: true,
            showEmptyStateIllustration: false
        },
        vip: {
            vipDashboardStyle: 'alternative4',
            vipAboutStyle: 'alternative',
            scaleRewardsImages: false,
            useMarkdownFaqs: false,
            heroCardOpacity: 0.9,
            rewardsTableLayout: 'summary',
            rewardsProgressPalette: 'warm',
            includeWageringRequirementRow: true,
            reorderPrimaryBenefitCards: true,
            testimonialsHeaderStyle: 'headline',
            useCompactTestimonialsCardHeight: true,
            faqListLength: 'short',
            usePrefixedVerbiageKeys: true,
            assetSet: 'elevated',
            negativeBadgeTone: 'rose',
            showRankPrefixBeforeDisplayName: false,
            useAccentPendingTotalsBadge: true,
            useBorderOnMiniVipCalendarCard: true,
            useCompactClubOverviewSectionHeights: true,
            useCompactRoyaltyBannerTypography: true,
            useExpandedRoyaltyBannerSectionSpacing: true,
            useGradientVipCalendarDateHeader: false,
            useTallerRoyaltyBannerOnNarrowScreens: true,
            showRoyaltyBannerInDashboard: false,
            calendarSummaryLabel: 'claimed',
            includeRaceInRakebackBreakdown: false,
            showVipRewardTooltips: false,
            monthlyRewardsTooltipStyle: 'compact',
            useClassicVipCalendarCardChrome: false,
            rakeboostProgressTone: 'accent'
        },
        progressBar: {
            showProgressIcon: false
        },
        profileDropdown: {
            showSupport: false,
            profileDropdownStyle: 'alternative',
            useAlternateProfileMenuChrome: true
        }
    },
    seo: seoConfig
};
const themeSettings = [
    {
        ...themeSetting,
        brand: 'luna-gamma.previewenv.net',
        languages: ['en', 'tr'],
        noIndex: true
    }
];
export const getThemeSetting = (domain, fullDomain) => {
    const setting = themeSettings.find((s) => fullDomain.includes(s.brand));
    if (setting)
        return setting;
    return themeSetting;
};
export const endpointSettings = [
    {
        name: 'luna',
        theme: Theme.Luna,
        base: 'monopoly-luna.prod.infinitro.dev',
        baseCurrency: 'TRY',
        baseCurrencySymbol: '₺',
        baseCurrencyDigits: 2,
        realm: 'prod-luna',
        catalogFilter: CatalogFilter.ReleaseGames,
        endpointType: EndpointType.Production,
        reownProjectId: '441421829a4cc3f2eaf2cccd9a34afff',
        optimoveTenantId: '1950',
        optimoveTenantToken: '144e2e7971da435b9bfbbcd943866483'
        // betbyBrandId: '2521642017990250504',
        // betbyEnabled: true,
        // betbyScriptUrl: 'https://fomo.sptpub.com/bt-renderer.min.js',
        // gamityBrandRef: 'luna',
        // gamityCurrency: 'USDT',
        // gamityEnvironment: 'production',
        // integrationRef: 'visionlink-gametech-as',
        // microsoftClarityId: 'u0hhgckxig'
    }
];
export const endpointSetting = (appMode, // eslint-disable-line @typescript-eslint/no-unused-vars
domain, // eslint-disable-line @typescript-eslint/no-unused-vars
fullDomain // eslint-disable-line @typescript-eslint/no-unused-vars
) => {
    return endpointSettings[0];
};
